import { AsoScenarioComputeMode } from '@ydistri/api-sdk';

export const ASO_SELECTS_ID = 'aso-selects';

export enum AsoComputeEntityMode {
  NEW = 'new',
  EXISTING = 'existing',
}

export interface CreateAsoParams {
  asoScenarioId: number;
  mode?: AsoScenarioComputeMode;
  calculationId?: number;
  entityListId?: number;
  title?: string;
  isNew?: boolean;
}
